import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {BeatLoader} from 'react-spinners';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal';
import Datetime from 'react-datetime';
import {_addNotification, _addNotificationError} from "../../../../server/util";
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
import { get,postWithHeadersResponse,postWithHeaders } from '../../../../server/actions'
import {Bar} from 'react-chartjs-2';
var _ = require('lodash');
const options={
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
        mode: 'label',
        callbacks: {
        label: function(tooltipItem, data) { 
            if(tooltipItem.datasetIndex==1){
                return data.datasets[tooltipItem.datasetIndex].label + ": $ " + numberWithCommas(tooltipItem.yLabel);
            }else{
                return data.datasets[tooltipItem.datasetIndex].label + ": " + numberWithCommas(tooltipItem.yLabel);
            }
        }
        }
    },
    scales: {
        yAxes: [{
                stacked:false,
                ticks: {
                    fontSize: 9,
                    min:0
                }
               }],
        xAxes: [{
                stacked:false,
                ticks: {
                    fontSize: 9,
                    min:0
                }
               }]
             },
             plugins: {
               datalabels: {
                  display: true,
                  align: 'top',
                  font: { size: '10',weight: 'bold' },
               }
            }
}
var numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
class BalTrund extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            selectedDates:{
                startDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).startOf('month'),
                endDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).endOf('month')
            },
            activeMonth:null,
            chartObj: {
                labels: [],
                datasets: [
                  {
                    label: 'Total Transactions',
                    backgroundColor: 'rgba(181, 213, 106, 1)',
                    borderColor: 'rgba(181, 213, 106, 1)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(181, 213, 106, 1)',
                    hoverBorderColor: 'rgba(181, 213, 106, 1)',
                    data: []
                  },
                  {
                    label: 'Total Amount',
                    backgroundColor: 'rgb(234, 112, 102)',
                    borderColor: 'rgb(234, 112, 102)',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgb(234, 112, 102)',
                    hoverBorderColor: 'rgb(234, 112, 102)',
                    data: []
                  }            
                ]
              }
        }
        this.init=this.init.bind(this)
        this.onChangeDateRange=this.onChangeDateRange.bind(this);
        this.getData=this.getData.bind(this);
    }
    componentWillMount=()=>{
        this.init();
    }
    init=()=>{
        this.onChangeDateRange(moment((this.props.activeMonth||moment()),'YYYYMM').startOf('month')
        ,moment((this.props.activeMonth||moment()),'YYYYMM').endOf('month'));
    }
    onChangeDateRange=(startDate,endDate)=>{  
        let _selectedDate={startDate:startDate,endDate:endDate}
        this.setState({selectedDates:_selectedDate},
            this.getData(_selectedDate.startDate,_selectedDate.endDate)
        );
    }
    componentWillReceiveProps=(nextProps)=> {
        if(this.state.activeMonth!==nextProps.activeMonth){
            let _selectedDate={
                startDate:moment((nextProps.activeMonth||moment()),'YYYYMM').startOf('month'),
                endDate:moment((nextProps.activeMonth||moment()),'YYYYMM').endOf('month')
            }
        this.setState({selectedDates:_selectedDate}
            ,this.getData(_selectedDate.startDate,_selectedDate.endDate))                
        }
    }
    getData=(startDate,endDate)=>{
        let dateStart = moment(startDate).utc().format("YYYY-MM-DDTHH:mm:ss");
        let dateEnd = moment(endDate).utc().format("YYYY-MM-DDTHH:mm:ss");     
        get('/dashboard/balancePaymentTrend?mealSchoolId=' + sessionStorage.getItem('SchoolId') 
        + '&startDate=' + dateStart + '&endDate=' + dateEnd +'&schoolYear=' + sessionStorage.getItem('schoolYearValue')+ '&access_token=').then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _chartObj=this.state.chartObj;
            
            _chartObj.labels=[];
            _chartObj.datasets[0].data=[];
            _chartObj.datasets[1].data=[];
            Object.keys(orders).map((key)=>{
                if(key!=='TransferCR'){
                    _chartObj.labels.push(key);
                    _chartObj.datasets[0].data.push(orders[key].totalTransactions);
                    _chartObj.datasets[1].data.push(orders[key].totalAmount);
                }                
            })
            this.setState({ chartObj:_chartObj,loading: false          
            })            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
    }
    render(){
        return(<div>
         <NotificationSystem ref="notificationSystem"/>  
         <div className="col-md-4">  
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>   
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                <span className="panel-title" style={{fontSize: '14px', fontWeight:'600'}}>
                Balance Payment Type</span>
                <div className="pull-right">
                <DateTimeRangePicker startDate={this.state.selectedDates.startDate} 
                endDate={this.state.selectedDates.endDate} 
                applyCallback={(event,picker)=>{
                    this.onChangeDateRange(picker.startDate,picker.endDate)}} 
                    isDateShow={false} />
                </div>
                <p style={{fontSize: '12px', fontWeight:'600'}}>{'Date Range: '+moment(this.state.selectedDates.startDate).format('DD-MMM-YYYY')+'   to '+moment(this.state.selectedDates.endDate).format('DD-MMM-YYYY')}</p>
            </div>
            <div className="panel-body" style={{padding:'0px'}}>        
            <Bar data={this.state.chartObj} options={options} onElementsClick={elems => {
                     if(elems.length>0){
                        console.log(elems[0]._datasetIndex + ', ' + elems[0]._index);
                        //let grade= elems[0]._model.label.replace('Grade-','');                                
                        let action='depSum';
                        let payType=elems[0]._model.label;
                        let startDate=moment(this.state.selectedDates.startDate).format('DD-MMM-YYYY');
                        let endDate=moment(this.state.selectedDates.endDate).format('DD-MMM-YYYY')
                        this.props.onElementClick(payType,action,startDate,endDate)
                        }                
                }} />
            </div>
            </div> 
        </div>
        </div>)
    }
}
export default BalTrund


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/BalTrund.jsx